import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { App, Form, Input, Button, Card, Result } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { authService } from '../services/auth.service';
import './ResetPassword.css';

const ResetPassword: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const { t } = useTranslation();
  const { message } = App.useApp();

  const onFinish = async (values: { email: string }) => {
    setLoading(true);
    try {
      await authService.resetPassword(values);
      setEmailSent(true);
    } catch (error: any) {
      message.error(error.response?.data?.message || t('auth.resetError'));
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div className="reset-password-container">
        <Card className="reset-password-card">
          <Result
            status="success"
            title={t('auth.resetEmailSent')}
            subTitle={t('auth.checkInbox')}
            extra={
              <Link to="/login">
                <Button type="primary" size="large">
                  {t('auth.backToLogin')}
                </Button>
              </Link>
            }
          />
        </Card>
      </div>
    );
  }

  return (
    <div className="reset-password-container">
      <Card className="reset-password-card">
        <div className="reset-password-header">
          <h1 className="reset-password-title">{t('app.title')}</h1>
          <p className="reset-password-subtitle">{t('auth.resetPassword')}</p>
        </div>
        
        <Form
          name="reset-password"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: t('auth.emailRequired') },
              { type: 'email', message: t('auth.emailInvalid') }
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder={t('auth.enterEmail')}
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
              block
            >
              {t('auth.sendResetLink')}
            </Button>
          </Form.Item>

          <Form.Item>
            <div className="reset-password-links">
              <Link to="/login" className="back-to-login-link">
                {t('auth.backToLogin')}
              </Link>
            </div>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ResetPassword;
